export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img4-81f937bc40f644487fa845b403b7d511.png";